import * as React from 'react';
export const consoleEntrySvg = React.forwardRef(function consoleEntrySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.25 0C15.216 0 16 .784 16 1.75v7.784a1.75 1.75 0 0 1-1.75 1.75H5a1.75 1.75 0 0 1-1.75-1.749V6.221h-1.5a.25.25 0 0 0-.25.25v7.784c0 .138.112.25.25.25H11a.25.25 0 0 0 .25-.25v-.446a.75.75 0 0 1 1.5 0v.446a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 14.255V6.47c0-.967.784-1.75 1.75-1.75h6.855l-.326-.326a.875.875 0 0 1 1.239-1.238l1.725 1.726a.876.876 0 0 1 0 1.237L9.518 7.846a.876.876 0 0 1-1.239-1.238l.388-.387H4.75v3.314a.25.25 0 0 0 .25.25h9.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v.446a.75.75 0 0 1-1.5 0V1.75C3.25.784 4.034 0 5 0h9.25Z',
    }),
  );
});
consoleEntrySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var consoleEntry = {
  category: 'icon',
  colorable: true,
  name: 'consoleEntry',
  svg: consoleEntrySvg,
};
